const LOCAL_KEY = "FOTOR_MINITOOL_AI_ACTION_FIGURE_NEW_TAGS"
export default class NewTagManage {
  private static instance: NewTagManage;
  private tags: string[] = [];

  private constructor() {
    const tags = localStorage.getItem(LOCAL_KEY);
    if (tags) {
      try {
        this.tags = JSON.parse(tags);
      } catch (error) {
        this.tags = [];
      }
      
    }
  }

  public static getInstance(): NewTagManage {
    if (!NewTagManage.instance) {
      NewTagManage.instance = new NewTagManage();
    }
    return NewTagManage.instance;
  }

  public addTag(tag: string): void {
    if (!this.tags.includes(tag)) {
      this.tags.push(tag);
      this.saveTags();
    }
  }

  public removeTag(tag: string): void {
    this.tags = this.tags.filter(t => t !== tag);
    this.saveTags();
  }

  public getTags(): string[] {
    return this.tags;
  }

  private saveTags(): void {
    localStorage.setItem(LOCAL_KEY, JSON.stringify(this.tags));
  }
}